import { render, staticRenderFns } from "./QualityControlTab.vue?vue&type=template&id=6daa00a9&scoped=true"
import script from "./QualityControlTab.vue?vue&type=script&lang=js"
export * from "./QualityControlTab.vue?vue&type=script&lang=js"
import style0 from "./QualityControlTab.vue?vue&type=style&index=0&id=6daa00a9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6daa00a9",
  null
  
)

export default component.exports